import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefundPolicyComponent } from './refund-policy.component';

@NgModule({
  imports: [CommonModule],
  declarations: [RefundPolicyComponent],
  exports: [RefundPolicyComponent],
})

export class RefundPolicyModule {}
